// Straight-line depreciation applied per completed year since purchase.
// A partial year does not depreciate — the original module deliberately
// floors the elapsed years rather than pro-rating. `today` is only passed by
// the summary's tests, which need a fixed date.
export const calculateCurrentValue = (purchaseCost, purchaseDateStr, depRateStr, today = new Date()) => {
  const cost = parseFloat(purchaseCost);
  if (isNaN(cost) || cost <= 0) return { current: 0, depreciated: 0 };

  const rate = parseFloat(depRateStr);
  if (isNaN(rate) || rate <= 0 || !purchaseDateStr) return { current: cost, depreciated: 0 };

  const purchased = new Date(purchaseDateStr);
  if (isNaN(purchased.getTime())) return { current: cost, depreciated: 0 };

  let years = today.getFullYear() - purchased.getFullYear();
  const beforeAnniversary =
    today.getMonth() < purchased.getMonth() ||
    (today.getMonth() === purchased.getMonth() && today.getDate() < purchased.getDate());
  if (beforeAnniversary) years -= 1;

  if (years <= 0) return { current: cost, depreciated: 0 };

  const totalDepreciated = cost * (rate / 100) * years;
  const current = Math.max(0, cost - totalDepreciated);

  return { current, depreciated: cost - current };
};

export default calculateCurrentValue;
